import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBigcommerceComponent } from './simple-icons-bigcommerce.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBigcommerceComponent ],
    exports:      [ SimpleIconsBigcommerceComponent ],
    bootstrap:    []
})
export class SimpleIconsBigcommerceModule {}
